import { render, staticRenderFns } from "./GroupTree.vue?vue&type=template&id=12735de2&scoped=true"
import script from "./GroupTree.vue?vue&type=script&lang=js"
export * from "./GroupTree.vue?vue&type=script&lang=js"
import style0 from "./GroupTree.vue?vue&type=style&index=0&id=12735de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12735de2",
  null
  
)

export default component.exports